import { FILE_SIZE_BASE } from '@/app-constants/common.contants';

export const shortenNumber = (num: number, floatingPoint: number = 1): string => {
  if (num === 0 || num === Infinity) return num.toString();
  else if (num >= 1e9) return (num / 1e9).toFixed(floatingPoint).replace(/\.0$/, '') + 'B';
  else if (num >= 1e6) return (num / 1e6).toFixed(floatingPoint).replace(/\.0$/, '') + 'M';
  else if (num >= 1e3) return (num / 1e3).toFixed(floatingPoint).replace(/\.0$/, '') + 'K';
  else return num.toFixed(floatingPoint).replace(/\.0$/, '').toString();
};

export const shortenFileSize = (size: number): string => {
  const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(FILE_SIZE_BASE));
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  return `${parseFloat((size / Math.pow(FILE_SIZE_BASE, i)).toFixed(2))}${sizes[i]}`;
};

export const numberFromCSSUnit = (unit: string): number => {
  const regex = RegExp(/\d+/);
  // get the start numbers from string then convert to number
  return Number(regex.exec(unit)[0]);
};
